<!-- DeleteCompanyModal.vue -->

<template>

  <div class="modal" id="deleteCompanyModal" tabindex="-1" aria-labelledby="deleteCompanyModalLabel" aria-hidden="true" ref="deleteCompanyModal">
    <div class="modal-dialog">

      <div class="modal-content shadow shadow-lg">
        <div class="modal-header border-bottom">
          <h5 class="modal-title">Delete Company</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <div class="modal-body">
          <div v-if="!isSubmitting">
            Are you sure you want to delete this company?
          </div>

          <div v-else>
            Deleting company and fetching list of companies...
          </div>
        </div>

        <div class="modal-footer">
          <span v-if="isDeleting('deletingCompany') || isSubmitting" class="ms-2 spinner-border spinner-border-sm text-secondary" role="status" aria-hidden="true"></span>
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" :disabled="isDeleting('deletingCompany') || isSubmitting">Cancel</button>
          <button type="button" class="btn btn-danger" @click="deleteRecord" :disabled="isDeleting('deletingCompany') || isSubmitting">Delete</button>
        </div>
      </div>

    </div>
  </div>

</template>

<script>
/* global bootstrap */
import { mapGetters } from 'vuex';

export default {
  name: 'DeleteCompanyModal',
  emits: [
    'showAlert',
    'showError',
  ],
  props: {
    recordId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      isSubmitting: false,
      modalInstance: null,
    };
  },

  computed: {
    ...mapGetters([
      'isCreating',
      'isFetching',
      'isUpdating',
      'isDeleting',

      'getProperty',
    ]),
  },

  watch: { },

  methods: {
    openModal() {
      if (!this.modalInstance) {
        const modalElement = this.$refs.deleteCompanyModal;
        this.modalInstance = new bootstrap.Modal(modalElement);
      }
      this.modalInstance.show();
    },

    closeModal() {
      if (this.modalInstance) {
        this.modalInstance.hide();
      }
    },

    async deleteRecord() {
      this.isSubmitting = true;

      try {
        await this.$store.dispatch('deleteRecord', {
          tableName: 'Companies',
          recordId: this.recordId,
          deletingStateVariable: 'deletingCompany',
        });

        await this.$store.dispatch('fetchRecords', {
          tableName: 'Companies',
          stateVariable: 'companies',
          fetchingStateVariable: 'fetchingCompanies',
        }),

        this.$emit('showAlert', 'success', 'Successfully deleted company');
        this.closeModal();

        this.$router.push('/companies');

      } catch (error) {
        this.$emit('showAlert', 'danger', 'Error deleting company: ' + error.message);
        console.error('Error deleting company: ', error);

      } finally {
        this.isSubmitting = false;
      }
    },
  },

  async mounted() { },

  created() { },
};
</script>